import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=da493e94&"
import script from "./ProductProperty.vue?vue&type=script&lang=js&"
export * from "./ProductProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports